module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Bold--6c2f0748902b1d0f447565b41df13ed0.eot";